export interface Concentration {
  number: number;
  unit: string;
}

export interface ListInventoryResponse {
  buffers: Buffer[];
  dnaParts: DnaPart[];
  enzymes: Enzyme[];
  libraries: Library[];
  oligos: Oligo[];
  reagents: Reagent[];
}

export interface Buffer {
  concentration?: Concentration | undefined;
  name: string;
}

export interface DnaPart {
  concentration?: Concentration | undefined;
  name: string;
}

export interface Enzyme {
  concentration?: Concentration | undefined;
  name: string;
}

export interface Library {
  concentration?: Concentration | undefined;
  name: string;
}

export interface Oligo {
  concentration?: Concentration | undefined;
  name: string;
}

export interface Reagent {
  concentration?: Concentration | undefined;
  name: string;
}

const STORAGE_KEY = 'petri:inventory';

function createDefaultInventory(): ListInventoryResponse {
  return {
    buffers: [{name: 'PBS', concentration: {number: 10, unit: 'x'}}],
    dnaParts: [],
    enzymes: [
      {
        name: 'Exonuclease III',
        concentration: {number: 5000, unit: 'U/ml'},
      },
      {
        name: 'Hi-T4 DNA Ligase',
        concentration: {number: 40000, unit: 'U/ml'},
      },
      {
        name: 'Q5 High-Fidelity 2X Master Mix',
        concentration: {number: 2, unit: 'x'},
      },
    ],
    libraries: [],
    oligos: [],
    reagents: [
      {name: 'Ethanol 80%', concentration: {number: 80, unit: '%'}},
      {
        name: 'SYBR Safe DNA Gel Stain',
        concentration: {number: 10000, unit: 'x'},
      },
    ],
  };
}

// Mutable inventory that loads from localStorage on first access
let _inventory: ListInventoryResponse | undefined;

export function getInventory(): ListInventoryResponse {
  if (!_inventory) {
    if (!process.env.CORGI_FOR_BROWSER) {
      _inventory = createDefaultInventory();
    } else {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
          _inventory = JSON.parse(raw) as ListInventoryResponse;
        } else {
          _inventory = createDefaultInventory();
        }
      } catch (e) {
        console.error('Failed to load inventory', e);
        _inventory = createDefaultInventory();
      }
    }
  }
  return _inventory;
}

export function setInventory(inventory: ListInventoryResponse): void {
  _inventory = inventory;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(inventory));
  } catch (e) {
    console.error('Failed to save inventory', e);
  }
}
